import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { getFarms, addFarm, addFarmCoord,assignationRequestApi, updateFarm as updateFarmData } from "services/farm.service";

export const useFarmData = () =>
  useQuery(["farms"], getFarms, {
    staleTime: "Infinity",
  });

export const addNewFarm = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: addFarm,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["farms"] });
    },
  });
};
export const assignationRequest = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: assignationRequestApi,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["assignations"] });
    },
  });
};

 export const prestataireData = async() => {
  useQuery(["prestatairesList"], async () => {
    const response = await request.get("assignation/getPrestataires");
    if (response.data.success) {
      return response.data.data;
    }
    return [];
  });
};
export const assignationActive = async(user_id) => {
  useQuery(["prestataires"], async () => {
    const response = await request.get(`assignation/assignations?farmerId=${user_id}&validate=false&reject=false`);
    if (response.data.success) {
      return response.data.data;
    }
    return [];
  });
};

export const addAndUpdateNewFarmCoords = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: addFarmCoord,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["coords"] });
    },
  });
};

export const updateFarm = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateFarmData,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["farms"] });
    },
  })
}
